import {S21CsaMyCsaComponent} from "./S21CsaMyCsaComponent";


export function S21CsaMyCsaScreen() {
  return (<>
    <S21CsaMyCsaComponent/>
  </>)
}
